import dayjs from "dayjs";
import { Passenger, Segment, VpvPaymentDto } from "./vpvPayment.dto";
import { INITIAL_SALE_EVENT_CONTEXT } from "../../../constants";
import { validateSessionByCookie } from "../../services/cookies";

const isRoundTrip = (flightSegments: Segment[]) => flightSegments.length > 1 && flightSegments[0].departureAirport === flightSegments[flightSegments.length - 1].arrivalAirport;

const getToIata = (flightSegments: Segment[], tripType: string) => {
  if (tripType === 'roundtrip') {
    if (flightSegments.length === 4) {
      return flightSegments[1].arrivalAirport;
    }
    return flightSegments[0].arrivalAirport;
  }

  return flightSegments.length > 1 ? flightSegments[1].arrivalAirport : flightSegments[0].arrivalAirport;
};

export const handleVpvPaymentEvent = (data: VpvPaymentDto) => {
  const { flightPassengers, flightSegments } = data;
  const {
    env: environment,
    isApp: app,
    isCorpo: corp,
  } = JSON.parse(localStorage.getItem(INITIAL_SALE_EVENT_CONTEXT) || "{}");

  const lastSegmentIndex = flightSegments.length - 1;
  
  const passengersAdults = flightPassengers?.filter((passenger: Passenger) => passenger.passengerAdultOrChild === 'ADT').length;
  const passengersChildren = flightPassengers?.filter((passenger: Passenger) => passenger.passengerAdultOrChild === 'CHD').length;
  const passengersInfants = flightPassengers?.filter((passenger: Passenger) => passenger.passengerAdultOrChild === 'INF').length;
  const passengersPet = flightPassengers?.filter((passenger: Passenger) => passenger.passengerAdultOrChild === 'PET').length;

  const tripType = isRoundTrip(flightSegments) ? 'roundtrip' : 'oneway';
  const fromIata = flightSegments[0].departureAirport;
  const toIata = getToIata(flightSegments, tripType);
  const fullTrip = flightSegments.map((segment: Segment) => `${segment.departureAirport}-${segment.arrivalAirport}`).join(',');

  const initialDate = dayjs(flightSegments[0].departureDateTime).format('YYYY-MM-DD');
  const endDate = dayjs(flightSegments[lastSegmentIndex].departureDateTime).format('YYYY-MM-DD');
  const time = flightSegments.map((segment: Segment) => (dayjs(segment.departureDateTime).format('HH:mm')) + `(${segment.departureAirport})`).join('|');

  const event = {
    event: 'vpv',
    event_params: {
      app,
      environment,
      corp,
      page_path: data.page_path || '/flujo-compra/pago',
      page_type: data.page_type || 'Pago',
      negocio: data.negocio || 'retail',
      micrositio: data.micrositio || 'mdp',
      homemarket: data.homemarket,
      buy_instance: data.stage,
      login: validateSessionByCookie() || corp,
      currency: data.currency,
      initial_date: initialDate,
      end_date: endDate,
      from_iata: fromIata,
      to_iata: toIata,
      trip_type: tripType,
      time,
      fare_basis: data.fare_basis,
      bundle: data.bundle,
      count_seats: data.count_seats,
      count_bags: data.count_bags,
      count_carry_on: data.count_carry_on,
      passengers_adult: passengersAdults,
      passengers_child: passengersChildren,
      passengers_infant: passengersInfants,
      passengers_pet: passengersPet,
      pax: flightPassengers.length,
      full_trip: fullTrip,
      exchange_rate: data.exchange_rate,
    }
  }

  return event;
}
